import React, { useState, useCallback } from 'react';
import Card from 'components/cards/Card01';
import Datepicker from 'components/actions/DatePicker';
import AnalyticsSerive from 'api/services/AnalyticsService';
import LayoutWrapper from 'components/LayoutWrapper';
import ChannelSelect from './ChannelSelect';
import LanguageSelect from './LanguageSelect';
import { useTranslation } from "react-i18next";
import { getChannelLanguageString, getDateRangeString, getI18nValue } from 'utils/Utils';
import { useAxios } from 'hooks/useAxios';
import { MdAccessTimeFilled } from 'react-icons/md'
import { RiRefreshFill, RiPercentFill } from 'react-icons/ri'
import { ImKey2 } from 'react-icons/im'
import { GoAlert } from 'react-icons/go'
import { HiLightBulb } from 'react-icons/hi'
import { FaMapMarkerAlt } from 'react-icons/fa'
import { ExportCSV } from 'components/ExportCSV';

function ConversationsByService() {
    const { t } = useTranslation();

    const [channel, setChannel] = useState('');
    const [language, setLanguage] = useState('');

    const [selectedDateRanges, setSelectedDateRanges] = useState(
        {
            startDate: new Date(new Date().setDate(new Date().getDate() - 30)),
            endDate: new Date(),
            key: 'selection',
        }
    );



    // Stable reference so MemoDatepicker never re-renders (setDateRanges is already
    // stable from useState, but useCallback makes the intent explicit).
    const handleDateChange = useCallback((newRanges) => setSelectedDateRanges(newRanges), []);

    const [data, error, loading] = useAxios(
        AnalyticsSerive.getConversationsByService(
            selectedDateRanges,
            channel,
            language
        )
    )



    return (

        <div className='p-4  col-span-full bg-white shadow-sm rounded-sm border border-gray-200 min-h-[320px]'>
            <div className="sm:flex sm:justify-between sm:items-center border-b border-blue-100 mb-4">
                <div className='mb-4'>
                    <header className='capitalize text-xl font-semibold text-gray-800 '>{t(getI18nValue('analytics.conversations_by_service', "title"))}</header>
                    <p className='text-sm font-light'>{t(getI18nValue('analytics.conversations_by_service', "description"))}</p>
                </div>
                <div className="flex items-center gap-2 flex-wrap mb-6 p-4 bg-white shadow-sm rounded-sm border border-gray-200">
                    <ExportCSV csvData={data} disabled={!data} fileName={`conversationsByService_${getDateRangeString(selectedDateRanges) + getChannelLanguageString(channel, language)}`} />
                    <ChannelSelect value={channel} onChange={setChannel} />
                    <LanguageSelect value={language} onChange={setLanguage} />
                    <Datepicker callBack={handleDateChange} />
                </div>
            </div>
            <LayoutWrapper error={error} loading={loading} variant="cards" isEmpty={!loading && !data}>
                <div className='grid grid-cols-1 md:grid-cols-4 gap-2' >
                    {!!data && Object.entries(data).map((item, i) => {
                        return (
                            <Card
                                key={item[0]}
                                title={t(getI18nValue(`analytics.conversations_by_service.${item[0]}`, "title"))}
                                description={t(getI18nValue(`analytics.conversations_by_service.${item[0]}`, "description"))}
                                value={item[1]}
                                icon={getServiceIcon(item[0])}
                            />
                        )
                    })}
                </div>
            </LayoutWrapper>

        </div >

    );
}

export default ConversationsByService;




export const getServiceIcon = (key) => {
    let iconList = {
        'horaire_tarif': < MdAccessTimeFilled />,
        'cancel_exchange': <RiRefreshFill />,
        'train_auto': < ImKey2 />,
        'reclamation': < GoAlert />,
        'astuce': <HiLightBulb />,
        'gare_proche': <FaMapMarkerAlt />,
        'tarif_reduit': <RiPercentFill />,
        'default': <div className='w-5 h-5' />
    };
    return (iconList[key] || iconList['default']);
}